<script>
  // Simple table. `columns` = header strings; `rows` = array of cell arrays.
  // Cells are rendered as text. For richer cells (bars, tags) build the table
  // inline in the screen instead.
  let { columns = [], rows = [] } = $props();
</script>

<div class="wf2-tablewrap" style="overflow-x:auto">
  <table class="wf2-table">
    {#if columns.length}
      <thead>
        <tr>{#each columns as c}<th>{c}</th>{/each}</tr>
      </thead>
    {/if}
    <tbody>
      {#each rows as row}
        <tr>{#each row as cell}<td>{cell}</td>{/each}</tr>
      {/each}
    </tbody>
  </table>
</div>
